import { useMutation } from '@biletiniz/apollo';
import { UPDATE_PROFILE } from './gql/update-profile';

export const useUpdateProfile = () => {
    const [updateProfileMutation, { error, loading }] = useMutation(
        UPDATE_PROFILE
    );

    const updateProfile = updateProfileInfo => {
        return updateProfileMutation({
            variables: updateProfileInfo,
        });
    };

    return {
        error: error?.message,
        updateProfile,
        loading,
    };
};
